import InputParameters from './InputParameters';

export default InputParameters;
